import { render, staticRenderFns } from "./CreateValidatorForm.vue?vue&type=template&id=65cabc85&"
import script from "./CreateValidatorForm.vue?vue&type=script&lang=js&"
export * from "./CreateValidatorForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateValidatorForm.vue?vue&type=style&index=0&id=65cabc85&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports